import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="col00">
        <div class="heading01 type01">
        <h1>{{ 'notification.Notifications' | translate }}</h1>
        </div>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
            <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('publishDate')"><a ng-click="vm.list.sortBy('publishDate')">{{ 'notification.Date' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('body')"><a ng-click="vm.list.sortBy('body')">{{ 'notification.Notification' | translate }}</a></th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items" ng-class="{status01: item.status === 'NOT_READ'}">
                    <td>{{ vm.moment(item.publishDate * 1000).format('DD.MM.YYYY HH:mm') }}</td>
                    <td>{{ item.body }}</td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor (moment, ListFactory, NotificationResource, DATATABLES, NOTIFICATION_TRANSPORT_ENUM) {
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.list = ListFactory.createWithPagination(NotificationResource.query.bind(NotificationResource));
        this.list.fetch({ transport: NOTIFICATION_TRANSPORT_ENUM.KEYS.FEED });
        NotificationResource.markAsRead();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/notifications/index.js